import { render, staticRenderFns } from "./TestEnvironmentBanner.vue?vue&type=template&id=2735f40e&scoped=true"
import script from "./TestEnvironmentBanner.vue?vue&type=script&lang=js"
export * from "./TestEnvironmentBanner.vue?vue&type=script&lang=js"
import style0 from "./TestEnvironmentBanner.vue?vue&type=style&index=0&id=2735f40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2735f40e",
  null
  
)

export default component.exports